import { DSAwardsPage } from 'shared-definitions/types'
import { ApiResponse, ApiAwardPageProps } from 'data-source/types.wp'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import {
  onePostWithAuthorMapper,
  OnePostWithAuthorMapperOpts,
} from 'data-source/mappers/onePostWithAuthorMapper'
import { paginationMapper } from 'data-source/mappers/paginationMapper'

interface CodecGetAwardsPageOpts extends MetaMapperOpts, OnePostWithAuthorMapperOpts {
  pagePath: string
}

export function codecGetAwardsPage(
  raw: ApiResponse<ApiAwardPageProps>,
  opts: CodecGetAwardsPageOpts
): DSAwardsPage {
  const input = raw.data
  return {
    head: headPropsMapper(input.head),
    ampPagePath: null,
    sections: null,
    meta: metaMapper({ ...input, content: {} }, ['Awards'], opts),
    pagePath: opts.pagePath,
    title: input.content.title,
    posts: {
      ...paginationMapper(input.content.content),
      items: input.content.content.posts.map(i => onePostWithAuthorMapper(i, opts)),
    },
    resource: 'awards-page',
  }
}
